import http from './httpservice';
import { Cookie } from '../utils/cookie';

const cookie: Cookie = new Cookie();
const language = cookie.ApiLanguage;
const baseUrl = '/api/v2/' + language;

const headers = {
    'Content-Type': 'application/json',
    'cache-control': 'no-cache',
    currentdatetime: new Cookie().CurrentDate,
};

const customerServiceBaseUrl = baseUrl + '/customerservice';

export const customerService = function() {
    return http.get(customerServiceBaseUrl, {
        headers: headers,
    });
};

export const getArticle = function(article) {
    return http.get(customerServiceBaseUrl + '/' + article, {
        headers: headers,
    });
};

export const searchArticle = function(term) {
    return http.get(customerServiceBaseUrl + '?SearchText=' + term, {
        headers: headers,
    });
};
